import styled from "styled-components";
import { device } from "../../styles/mediaQueries";

export const Wrapper = styled.section`
  margin: 0 0.7rem 8rem;
  @media (${device.tablet}) {
    max-width: 1080px;
    padding: 0 0.7rem;
    margin: 0 auto 8rem;
  }
`;
